import {
    StyleSheet
} from "react-native";

export default StyleSheet.create({
    container: {
        overflow: "hidden",
        width: 120,
        height: 85,
        backgroundColor: "#FFFFFF",
        justifyContent: "center",
        alignItems: "center"
    },
    image:{
        resizeMode: "contain",
        width: "100%",
        height: "100%"
    }
});
